import { cn } from '@/utils';
import { memo } from 'react';

export type SelectFormProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
	options?: { id: number; value: string; label: string }[];
	className?: string;
	value: string;
	onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	containerClassName?: string;
	boxStyle?: React.CSSProperties;
};

const SelectForm = ({
	options = [],
	value,
	onChange,
	className,
	containerClassName,
	boxStyle,
	...rest
}: SelectFormProps) => {
	return (
		<div className={containerClassName} style={boxStyle}>
			<select
				className={cn(
					'appearance-none bg-inherit border-none text-[10px] h-[18px] outline-0 text-center',
					className
				)}
				value={value}
				onChange={onChange}
				data-value={value}
				{...rest}
			>
				{options?.map((x) => (
					<option key={x.id} value={x.value}>
						{x.label}
					</option>
				))}
			</select>
		</div>
	);
};

export default memo(SelectForm);
